import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { navItems } from './sidebar-data';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppHorizontalNavItemComponent } from './nav-item/nav-item.component';
import { CommonModule } from '@angular/common';
import { SearchListComponent } from 'src/app/components/forms/search-list/search-list.component';
import { MatDialog } from '@angular/material/dialog';
import { MaterialModule } from 'src/app/material.module';
import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';
import { HORIZONTAL_MENU_MEDIA } from '../horizontal-layout.constants';

@Component({
  selector: 'app-horizontal-sidebar',
  standalone: true,
  imports: [AppHorizontalNavItemComponent, CommonModule, SearchListComponent, MaterialModule],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})

export class AppHorizontalSidebarComponent implements OnInit {
  navItems = navItems;
  parentActive = '';
  filteredNavItems:NavItem[];
  userRole: string = ''; // Valor por defecto, se actualizará después
  
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  // Configuración para el SearchListComponent
  searchConfig = {
    view: "vc_cat_maestros",
    value: "id",
    dataNames: ['rfc', 'nombre', 'apellido_paterno', 'apellido_materno', 'clave_presupuestal_matutino', 'patente']
  };

  constructor(
    public router: Router,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    this.mobileQuery = media.matchMedia(HORIZONTAL_MENU_MEDIA);
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.router.events.subscribe(
      () => (this.parentActive = this.router.url.split('/')[1])
    );
    this.userRole = localStorage.getItem('role') || "";
    this.filteredNavItems = this.navItems.filter(item => this.hasAccess(item));
  }

  ngOnInit(): void { }

  hasAccess(item: NavItem): boolean {
    // Comentario: los separadores no se filtran por rol
    if (item.separator) {
      return true;
    }
    // Verifica si el usuario actual tiene al menos uno de los roles requeridos para el item
    if (item.role && item.role.length > 0) {
      if (!this.userRole) { return false; }
      const hasRole = item.role.some(r => this.userRole.includes(r));
      if (!hasRole) { return false; }
    }
    // Si el ítem tiene children, también se pueden filtrar
    if (item.children && item.children.length > 0) {
      item.children = this.limpiarSeparadoresMenu(
        item.children.filter(child => this.hasAccess(child)),
      );
      return item.children.length > 0;
    }
    return true;
  }

  /** Elimina separadores huérfanos o duplicados tras filtrar por rol */
  private limpiarSeparadoresMenu(children: NavItem[]): NavItem[] {
    const resultado: NavItem[] = [];
  // Comentario: evita separadores al inicio, al final o consecutivos
    for (const child of children) {
      if (child.separator) {
        if (resultado.length === 0) {
          continue;
        }
        if (resultado[resultado.length - 1].separator) {
          continue;
        }
        resultado.push(child);
        continue;
      }
      resultado.push(child);
    }
    if (resultado.length > 0 && resultado[resultado.length - 1].separator) {
      resultado.pop();
    }
    return resultado;
  }

  // Método para manejar la selección de elementos
  handleSearchSelection(event: any): void {
    if (event && event.event && event.event.itemData) {
      const item = event.event.itemData;
      // Forzar una recarga completa navegando primero a una ruta intermedia
      this.router.navigate(['/']).then(() => {
        this.router.navigate(['/kardex'], { queryParams: { id: item.id } });
      });
    }
  }

}
